import React, { useState, useEffect, useRef, useContext } from "react";
import ReactMarkdown from 'react-markdown';
import styled from "styled-components";
import { Icons, MapControlButton } from "kepler.gl/components";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import "./chat-map-control.css";
import axios from "axios";
import { VscHubot } from "react-icons/vsc";
import { AiOutlineClose, AiOutlineLike, AiOutlineDislike, AiFillLike, AiFillDislike, AiOutlineReload } from "react-icons/ai";
import { BsFillSendFill } from "react-icons/bs";
import { LuCopy, LuCopyCheck, LuFile, LuPlus } from "react-icons/lu";
import { MdAttachFile } from "react-icons/md";
import { RiDeleteBin6Fill } from "react-icons/ri";
import { CodeBlock, dracula } from "react-code-blocks";
import {BouncingDotsLoader, ProgressLoader} from "../loader";
// import ApexChart from "../chart";
import { useDispatch } from "react-redux";
import { loadFiles, addDataToMap } from "kepler.gl/actions";
import { processCsvData, processGeojson } from "kepler.gl/processors";
import { AUTH_TOKENS } from "../../constants/default-settings";
import { configureAWS } from "../../constants/aws-configure";
import { uid } from 'uid';
import { AuthContext } from "../../cognito/AuthContext";
import { refreshToken } from "../../cognito/cognitoUtils";
import { chatHistory, chat, deleteChat } from "./chat-history";
import { config } from "aws-sdk";
const hljs = require('highlight.js');
const languages_list = hljs.listLanguages();
import Plot from 'react-plotly.js';


// Styled components
const StyledFloatingPanel = styled.div`
  z-index: 10;
  margin-right: 12px;
  margin-top: 20px;
`;

const StyledModal = styled.div`
  background-color: ${(props) => props.theme.panelBackground};
  position: relative;
  width: 100%;
  height: 100%;
`;

const contentStyle = () => ({
  height: "100%",
  width: "90%",
});

export function ChatBotPanel(props) {
  const [input, setInput] = useState("")
  const [data, setData] = useState("");
  const [messages, setMessages] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isUploading, setUploading] = useState(false)
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [fail, setFail] = useState(false);
  const [copied, setCopied] = useState(false);
  const [files, setFiles] = useState([]);
  const [geometry, setGeometry] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({});
  const [history, setHistory] = useState([]);
  // const [s3, setS3] = useState(null);
  const [abortController, setAbortController] = useState(null); 
  const [temp, setTemp] = useState([])
  const [responses, setResponses] = useState({})

  const chatId = useRef(uid(6));
  const hiddenFileInput = useRef(null);
  const messagesEndRef = useRef(null);

  const dispatch = useDispatch();

  const s3_bucket = AUTH_TOKENS.S3_BUCKET;
  const prefix = process.env.PREFIX_UPLOAD
  const api_endpoint = process.env.API_ENDPOINT

  const { user, id_token, setIdToken, s3, setS3 } = useContext(AuthContext);

  // useEffect(() => {
  //   console.log(api_endpoint)
  //   console.log("Chat ID:", chatId);
  //   console.log(user)
  // }, []);

  //Fetch chat history.
  const fetchChatHistory = async () => {
    try {
      const chatData = await chatHistory(id_token, user.username);
      setHistory(chatData);
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  const fetchChat = async (chat_id) => {
    try {
      chatId.current = chat_id
      // console.log(chatId.current)
      const chatMessage = await chat(id_token, user.username, chat_id)
      setMessages(chatMessage)
      setResponses({})
      for (let message of chatMessage) {
        setResponses((prevResponses) => ({
          ...prevResponses,
          [message.message_id]: message.user_response,
        }));
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    }
  };

  useEffect(()=>{
    // console.log('fetch chat')
    fetchChatHistory();  
    fetchChat(chatId.current)  
  },[])

  // useEffect(()=>{
  //   const interval = setInterval(() => {
  //     fetchChatHistory()
  //   },5000);
  //   return () => clearInterval(interval);
  // })

  useEffect(() => {
    const interval = setInterval(() => {
      refreshToken(setIdToken, setS3, id_token)
    }, 5 * 60 * 1000); 
  
    return () => clearInterval(interval); 
  }, []);
  

  // useEffect(() => {
  //   console.log(temp);
  // }, [temp]);

  // useEffect(() => {
  //   console.log(messages[messages.length - 1])
  // }, [messages])

  const createAbortController = () => {
    const controller = new AbortController();
    setAbortController(controller);
    return controller;
  };

  //Upload files to S3
  const uploadFile = async (controller) => {
    const urls = [];
    setUploading(true)

    for (const file of files) {
      const params = {
        Bucket: s3_bucket,
        Key: `${prefix}${file.name}`,
        Body: file,
      };

      try {
        const managedUpload = s3.upload(params);

        managedUpload.on("httpUploadProgress", (progress) => {
          if (controller.signal.aborted) {
            managedUpload.abort();
            return;
          }
          const percent = Math.round((progress.loaded / progress.total) * 100);
          setUploadProgress((prevProgress) => ({
            ...prevProgress,
            [file.name]: percent,
          }));
        });

        await managedUpload.promise();
        const url = `${s3_bucket}/${prefix}${file.name}`;
        urls.push(url);
      } catch (error) {
        if (controller.signal.aborted) {
          console.log("Upload interrupted.");
        } else {
          console.error("Error uploading file:", error);
        }
      }
    }

    setFiles([]);
    setUploadProgress({});
    setUploading(false)
    return urls
  };


  const handleChange = (e) => {
    setInput(e.target.value)
    setData(e.target.value)
  };

  const handleSubmit = async (e, regenerate = false, user_input = null) => {
    if (e) e.preventDefault();

    const inputText = user_input ?? data;
    if ((inputText.trim() === "") && (regenerate == false)) {
      console.log("Input is empty or only contains spaces");
      return;
    }

    const controller = createAbortController();

    try {
      setInput("")
      setFail(false)
      let input = { user_input: inputText };
      input.files = []
      if (regenerate == false){
        setTemp([inputText])
        if (files.length !== 0) {
          const urls = await uploadFile(controller); 
          if (controller.signal.aborted) return;
          input.files = urls; 
          setTemp((prevTemp) => [...prevTemp, urls]);
        }
        else{
          setTemp((prevTemp) => [...prevTemp, []]);
        }
      }

      // console.log('regenerate', regenerate)
      if(regenerate){
        messages.pop()
        input.user_input = temp[0]
        if(temp[1].length > 0){
          input.files = temp[1]
        }
      }

      // console.log(chatId.current)
      input.username = user.username
      input.chat_id = chatId.current
      const message_id = uid(16)
      input.message_id = message_id

      const newMessage = { sender: "you", message_id : message_id, text: input.user_input, files: input.files };
      setMessages((prevMessages) => [...prevMessages, newMessage]);
      setLoading(true);
      // console.log(input)
      const res = await axios.post(
        api_endpoint + '/chat',
        input,
        {
          headers: {
            'AUthorization' : id_token,
          },
          signal: controller.signal
        }
      );

      if (controller.signal.aborted) return;
      // console.log(res.data)
      const botMessage = {
        sender: "bot",
        message_id : message_id,
        text: res.data.output,
        json: res.data.json,
        object: res.data.file,
        user_response : null
      };
      fetchChatHistory()
      setGeometry(res.data.geojson)
      setMessages((prevMessages) => [...prevMessages, botMessage]);
      // console.log(messages)
    } catch (error) {
      if (controller.signal.aborted) {
        console.log("Request interrupted.");
      } else {
        console.error("Error in handleSubmit:", error);
        setFail(true)
        // window.location.reload();
      }
    } finally {
      setLoading(false);
      setData("")
    }
  };

  // Re-generate answer
  const reGenerate = (user_input = null, regenerate = false) => {
    handleSubmit(null, regenerate, user_input)
  }


  const userResponse = async (message_id, user_response, like) => {
    const input = {'username': user.username,'chat_id' : chatId.current, 'message_id' : message_id }
    if (responses[message_id] != null && user_response === like){
      // console.log('there is response')
      input["user_response"] = null
    }
    else{
      input["user_response"] = like
    }
    setResponses((prevResponses) => {
      if (prevResponses[message_id] === like) {
        const { [message_id]: _, ...rest } = prevResponses;
        // console.log(rest)
        return rest;
      } else {
        return {
          ...prevResponses,
          [message_id]: like,
        };
      }
    });
    
    const res = await axios.patch(
      api_endpoint + '/user-response',
      input,
      {
        headers: {
            'AUthorization' : id_token,
          }
      }
    );

    // console.log(res)
  };
  

  //Interrupting generate answer 
  const handleInterrupt = () => {
    if (abortController) {
      abortController.abort(); 
      setLoading(false);
      setUploading(false)
      setTemp([])
      setAbortController(null); 
    }
  };

  const handleCopyCode = (code) => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
      })
      .catch((err) => console.error("Failed to copy code:", err));
  };

  //Restrict file size to 100MB.
  const handleFile = (file) => {
    if (file.size > 100 * 1024 * 1024) { 
      // console.log("File size exceeds limit. Maximum size allowed is 100 MB.");
      return false; 
    }
    return true; 
  };

  //Handle selected files.
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files); 
    let validFiles = [];
  
    selectedFiles.forEach((file) => {
      if (validFiles.length < 5 && handleFile(file)) {
        validFiles.push(file);
      }
    });
  
    setFiles((prevFiles) => {
      const totalFiles = [...prevFiles, ...validFiles].slice(0, 5);
      return totalFiles;
    });
  
    e.target.value = ""; 
  };

  const handleAttachClick = () => {
    hiddenFileInput.current.click();
  };

  //Clear selected files.
  const clear = (indexToRemove) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove)
    );
  };
  
  //Download file from link.
  const downloadFile = async (fileName) => {
    const params = {
      Bucket: s3_bucket,
      Key: `${prefix}${fileName}`, 
    };

    s3.getObject(params, (err, data) => {
      if (err) {
        console.error('Error downloading file:', err);
        return;
      }

      const blob = new Blob([data.Body], { type: data.ContentType });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = fileName; 
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(url); 
    });
  };

  //Auto-scroll chatbot to bottom.
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading, isUploading]);

  //Auto-scroll chatbot to bottom.
  useEffect(() => {
    if (isPopupOpen) {
      const timer = setTimeout(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [isPopupOpen]);

  // Block form submission on Shift+Enter.
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <StyledFloatingPanel>
      <Popup
        trigger={
          <MapControlButton title="Click here to submit your data">
            <VscHubot size={18} />
          </MapControlButton>
        }
        modal
        contentStyle={contentStyle}
        nested
        closeOnDocumentClick={false}
        closeOnEscape={false}
        onOpen={() => setPopupOpen(true)}
        onClose={() => setPopupOpen(false)}
      >
        {(close) => {
          const closePopup = () => close();

          useEffect(() => {
            try {
              if (geometry && Object.keys(geometry).length > 0) {
                if (geometry.config){
                  dispatch(
                    addDataToMap({
                      datasets: [
                        {
                          info: {
                                label: geometry.config.config.visState.layers[0].config.label,
                                id: geometry.config.config.visState.layers[0].config.dataId
                              },
                          data: processGeojson(geometry.data),
                        },
                      ],
                      config: geometry.config
                    })
                  );
                }
                else{
                  dispatch(
                    addDataToMap({
                      datasets: [
                        {
                          data : processGeojson(geometry.data),
                        }
                      ],
                    })
                  );                  
                }
                {/* console.log("Added data successfully"); */}
                closePopup();
                setGeometry(null);
              }
            } catch (error) {
              setGeometry(null);
            }
          }, [geometry, dispatch]);
          return (
            <StyledModal>
              <div className="modal">
                <div className="side-body">
                  <div className="header-side-body">
                    <p>Chat History</p>
                    <LuPlus 
                    className="new-chat-button" 
                    size={24} 
                    onClick={() => {
                      chatId.current = uid(6)
                      fetchChat(chatId.current)
                    }}/>
                  </div>
                  <div className="chat-history">
                    {history.map((item, index) => (
                      <div className="chat-id" key={index} onClick={() => fetchChat(item.chat_id)}>
                        <p>{item.human_message}</p>
                        <RiDeleteBin6Fill className="delete-chat-button" size={14} 
                        onClick={async (e) => {
                          e.stopPropagation()
                          await deleteChat(id_token, user.username, item.chat_id)
                          fetchChatHistory()
                          chatId.current = uid(6)
                          fetchChat(chatId.current)
                        }}/>
                      </div>                  
                    ))}
                  </div>
                </div>
                <div className="main-body">
                  <div className="header">
                    <p>Chat Bot</p>
                    <AiOutlineClose
                      className="close-button"
                      size={30}
                      onClick={close}
                    />
                  </div>
                  <div className="content">
                    <div className="message-box">
                      {messages.map((message, index) => (
                        <div
                          key={index}
                          className={`message-box-${message.sender}`}
                        >
                          {message.sender}
                          {message.sender === "you" && message.files != null &&
                              <div className="file-history">
                                { message.files.map((file, index) => (
                                  <div key={index} className="file-uploaded">
                                    <div className="icon-wrapper">
                                      <LuFile size={24} />
                                    </div>   
                                    {file.split("/RAW/temporary_upload/")[1]}                           
                                    {/* <div className="text-wrapper">                                    
                                      {file.split("/RAW/temporary_upload/")[1]}
                                    </div> */}
                                  </div>
                                ))}
                              </div>
                            }
                          <div className={`message-${message.sender}`}>
                            {message.sender === "bot" &&
                            Object.keys(message.json).length > 0 ? (                              
                              <div style={{ width: "100%", height: "60vh"}}>
                                <Plot
                                  data={message.json.data}
                                  layout={{ ...message.json.layout, autosize: true }}
                                  style={{ width: "100%", height: "100%" }} // Apply CSS styles
                                />
                              </div>
                            ) : null}    
                            {message.text
                            .split(/(```[\s\S]*?```)/)
                            .map((segment, i) => {
                              if (segment.startsWith("```") && segment.endsWith("```")) {
                                const codeContent = segment.slice(3, -3).trim();
                                if (codeContent === "") {
                                  // If the code block is empty, render it as plain text or skip rendering
                                  return <ReactMarkdown key={'block-' + i}>{segment}</ReactMarkdown>;
                                }
                                const [firstLine, ...codeLines] = codeContent.split("\n");
                                const language = firstLine.trim();
                                const code = codeLines.length > 0 ? codeLines.join("\n") : language;

                                return (
                                  <React.Fragment key={'block-' + i}>
                                    {languages_list.includes(language) ? (
                                      <div
                                        style={{
                                          position: "relative",
                                          width: "100%",
                                          marginBottom: "10px",
                                          overflowWrap: "break-word",
                                          wordWrap: "break-word",
                                          wordBreak: "break-word",
                                          display: "inline-block",
                                        }}
                                      >
                                        <pre className="code-snippets">
                                          <div className="header-code-snippets">
                                            {language && <div>{language}</div>}
                                            <button
                                              onClick={() => handleCopyCode(code)}
                                              className="copy-code-button"
                                            >
                                              {copied ? (
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  copied! <LuCopyCheck size={18} />
                                                </div>
                                              ) : (
                                                <LuCopy size={18} />
                                              )}
                                            </button>
                                          </div>
                                          <div className="body-code-snippets">
                                            <CodeBlock
                                              text={code}
                                              language={language}
                                              theme={dracula}
                                            />
                                          </div>
                                        </pre>
                                      </div>
                                    ) : (
                                      <ReactMarkdown>{code}</ReactMarkdown>
                                    )}
                                  </React.Fragment>
                                );
                              } else {
                                return <ReactMarkdown key={'block-' + i}>{segment}</ReactMarkdown>;
                              }
                            })}
                            {message.sender === "bot" && message.object && <div className="download-link" onClick={() => downloadFile(message.object)}>{message.object}</div>}
                          </div>
                          {message.sender === "bot" &&
                          <div className="action-chat-button">
                            <div className="regerenate-icon" onClick={() => reGenerate(messages[index-1].text)}>
                              <AiOutlineReload size={20}/>
                            </div>
                            <div className="like-icon" onClick={() => userResponse(message.message_id, responses[message.message_id], true)}>
                              {responses[message.message_id] ? <AiFillLike size={20}/> : <AiOutlineLike size={20}/>}
                            </div>
                            <div className="dislike-icon" onClick={() => userResponse(message.message_id, responses[message.message_id], false)}>
                              {responses[message.message_id] === false ? <AiFillDislike size={20}/> : <AiOutlineDislike size={20}/>}
                            </div>
                          </div>
                          }
                        </div>
                      ))}
                      {isLoading && <BouncingDotsLoader />}
                      {fail && 
                      <div 
                        className="regenerate-button" 
                        onClick={reGenerate(null, true)}>
                        regenerate
                      </div>}
                      <div ref={messagesEndRef} />
                    </div>
                    {files.length !== 0 && (
                      <div className="file-area">
                        {files.map((file, index) => (
                          <div key={index} className="file">
                            {/* <div className='tooltiptext'>{item.name}</div> */}
                            <div className="file-name">{file.name}</div>
                            <div className="clear-file">
                            {  isUploading ? <ProgressLoader progress={uploadProgress[file.name] || 0}/> : 
                              <AiOutlineClose
                                className="close-button"
                                size={18}
                                onClick={() => clear(index)}
                              />
                            }
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <form onSubmit={handleSubmit}>
                      <div
                        className="attach-file-button"
                        onClick={() => {
                          if (!(isLoading || isUploading)) {
                            handleAttachClick();
                          }
                        }}
                      >
                        <MdAttachFile className="attach-file-button" size={30} />
                      </div>
                      <input
                        type="file"
                        ref={hiddenFileInput}
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        multiple 
                        accept=".txt, .csv, .json, .geojson, .pdf"
                      />
                      <textarea
                        className="textarea-question"
                        placeholder={(isLoading || isUploading) ? "Waiting..." : "Ask me"}
                        value={input}
                        onChange={handleChange}
                        onKeyDown={handleKeyDown}
                        disabled={(isLoading || isUploading)}
                      />
                      <div
                        className="submit-container"
                        onClick={() => {
                          if (!(isLoading || isUploading)) {
                            document.getElementById("submit-input").click();
                          }
                          else{
                            handleInterrupt()
                          }
                        }}
                      >
                      {!(isLoading || isUploading) ? <BsFillSendFill size={30} /> : <AiOutlineClose size={30}/>}
                        <input
                          type="submit"
                          id="submit-input"
                          style={{ display: "none" }}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </StyledModal>
          );
        }}
      </Popup>
    </StyledFloatingPanel>
  );
}
